import { createFileRoute } from '@tanstack/react-router'
import { useCommunicationTemplates } from '@/api/hooks/useCommunicationTemplates'
import CommunicationTemplateDetails from '@/components/organisms/communication-template-details'
import { PermissionsUtils } from '@/utils/permissions.utils'

export const Route = createFileRoute('/_authenticated/communication-template/$templateId')({
  component: CommunicationTemplateRoute,
})

function CommunicationTemplateRoute() {
  const { templateId } = Route.useParams()
  const { data: templates } = useCommunicationTemplates({ scope: ['global', 'workshop'] })

  if (!PermissionsUtils.hasPermission('communication-templates:read')) return null

  const template = templates.find(t => t.id === templateId)
  if (!template) return null

  return <CommunicationTemplateDetails key={template.id} template={template} />
}
